/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Error Page
*/

module.exports = {
  /* 01.General */
  'general.copyright': 'Gogo React © 2018 All Rights Reserved.',

  'unauthorized.title': 'Acceso negado',
  'unauthorized.detail':
    'No estas autorizado para ver esta pagina.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'Ingresar',
  'user.register': 'Registrarse',
  'user.forgot-password': 'Forgot Password',
  'user.email': 'Email',
  'user.password': 'Contraseña',
  'user.forgot-password-question': '¿Olvido la contraseña?',
  'user.fullname': 'Nombre completo',
  'user.login-button': 'Iniciar Sesión',
  'user.register-button': 'Registrarse',
  'user.reset-password-button': 'Restablecer contraseña',
  'user.buy': 'BUY',
  'user.username': 'Ususario',

  /* 03.Menu */
  'menu.home': 'Home',
  'menu.app': 'Home',
  'menu.dashboards': 'Dashboards',
  'menu.gogo': 'Gogo',
  'menu.start': 'Inicio',
  'menu.second-menu': 'Menú Secundario',
  'menu.second': 'Second',
  'menu.ui': 'UI',
  'menu.charts': 'Charts',
  'menu.chat': 'Chat',
  'menu.survey': 'Survey',
  'menu.todo': 'Todo',
  'menu.search': 'Search',
  'menu.docs': 'Docs',
  'menu.blank-page': 'Blank Page',

  /* 04.Error Page */
  'pages.error-title': 'Ooops... a ocurrido un error!',
  'pages.error-code': 'Error Code',
  'pages.go-back-home': 'Ir a la página de inicio',
};
